import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import AdminLayout from '../Componets/AdminLayout';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { IoSettings } from 'react-icons/io5';

export default function EditExam() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {};
  const [isLoading, setIsLoading] = useState(false);
  const focusInputRef = useRef(null);
  const [subjectList, setSubjectList] = useState([]);
  const [programs, setPrograms] = useState([]);
  const currentPath = location?.pathname || '';
  const [value, setValue] = useState({
    name: '',
    programId: '',
    isLocked: false,
    facultyCount: 0,
    subjects: [],
  });

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'ADMIN') {
      navigate('/');
    }
    focus();
  }, [navigate]);

  const focus = () => {
    if (focusInputRef.current) {
      focusInputRef.current.focus();
    }
  };

  // Fetch available subjects and programs when the component mounts
  useEffect(() => {
    const token = localStorage.getItem('token');

    // Fetch subjects
    axios
      .get(`${apiUrl}/api/subject`, {
        headers: { Authorization: `${token}` },
      })
      .then((res) => {
        setSubjectList(res.data.subjects);
      })
      .catch((err) => {
        console.error(err);
        err.response?.status === 401 && navigate('/');
      });

    // Fetch programs
    axios
      .get(`${apiUrl}/api/program/`, {
        headers: { Authorization: `${token}` },
      })
      .then((res) => {
        setPrograms(res.data.programs);
      })
      .catch((err) => {
        console.error(err);
        err.response?.status === 401 && navigate('/');
      });
  }, [apiUrl, navigate]);

  // Fetch exam data
  useEffect(() => {
    const token = localStorage.getItem('token');
    axios
      .get(`${apiUrl}/api/exam/${id}`, {
        headers: { Authorization: `${token}` },
      })
      .then((res) => {
        setValue({
          name: res.data.name,
          programId: res.data.program?.id || '',
          isLocked: res.data.isLocked || false,
          facultyCount: res.data.facultyCount || 1,
          subjects:
            res.data.subjects.map((subject) => ({
              ...subject,
              isLocked: subject.isLocked || false,
              internalPassMark: subject.internalPassMark || '',
              internalTotalMark: subject.internalTotalMark || '',
              omrTotalMark:
                subject.omrTotalMark > 0 ? +subject.omrTotalMark : null,
              isOmrMarks: subject.omrTotalMark > 0 ? true : false,
            })) || [],
        });
      })
      .catch((err) => {
        console.error(err);
        err.response?.status === 401 && navigate('/');
      });
  }, [apiUrl, id, navigate]);

  const handleAddSubject = () => {
    setValue((prevState) => ({
      ...prevState,
      subjects: [
        ...prevState.subjects,
        {
          subjectId: '',
          totalMarks: '',
          passingMarks: '',
          internalPassMark: '',
          internalTotalMark: '',
          isLocked: false,
          omrTotalMark: '',
          isOmrMarks: false,
        },
      ],
    }));
  };

  const prepareDataForSubmission = (data) => {
    return {
      ...data,
      programId: +data.programId,
      subjects: data.subjects.map((subject) => ({
        subjectId: +subject.subjectId,
        passingMarks: +subject.passingMarks,
        totalMarks: +subject.totalMarks,
        internalPassMark: +subject.internalPassMark,
        internalTotalMark: +subject.internalTotalMark,
        omrTotalMark: +subject.omrTotalMark > 0 ? +subject.omrTotalMark : null,
        isOmrMarks: subject.omrTotalMark > 0 ? true : false,
      })),
    };
  };

  const handleSubmit = (e) => {
    setIsLoading(true);
    e.preventDefault();
    const token = localStorage.getItem('token');

    const updatedValue = prepareDataForSubmission({
      ...value,
      isLocked: value.isLocked,
      facultyCount: value.facultyCount,
    });

    axios
      .put(`${apiUrl}/api/exam/${id}`, updatedValue, {
        headers: { Authorization: `${token}` },
      })
      .then((res) => {
        setIsLoading(false);
        focus();
        toast.success('Exam information updated successfully');

        if (currentPath === '/EditExam') {
          const timeOutDuration = 3000;
          const timeoutId = setTimeout(() => {
            if (window.location.pathname === '/EditExam') {
              navigate(-1);
            }
          }, timeOutDuration);
          return () => clearTimeout(timeoutId);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error(err.response.data.message);
        err.response?.status === 401 && navigate('/');
      });
  };

  const handleDeleteSubject = (index) => {
    const updatedSubjects = [...value.subjects];
    updatedSubjects.splice(index, 1);
    setValue({ ...value, subjects: updatedSubjects });
  };

  const getAvailableSubjects = (index) => {
    const selectedSubjectIds = value.subjects.map((subject) =>
      parseInt(subject.subjectId)
    );
    return subjectList.filter(
      (subject) =>
        !selectedSubjectIds.includes(subject.id) ||
        selectedSubjectIds[index] === subject.id
    );
  };

  return (
    <AdminLayout ac4="active">
      <main id="main" className="main">
        <div className="pagetitle">
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/AdminHome">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/ListExam">View Exam</Link>
              </li>
              <li className="breadcrumb-item active">Edit Exam</li>
            </ol>
          </nav>
        </div>
        <section className="section col-lg-12">
          <div className="row">
            <div className="">
              <div className="card">
                <div className="card-body mx-3 pt-5">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-floating mb-2">
                          <input
                            ref={focusInputRef}
                            className="form-control"
                            type="text"
                            placeholder="Name"
                            value={value.name}
                            onChange={(e) =>
                              setValue({ ...value, name: e.target.value })
                            }
                            required
                          />
                          <label className="form-label" htmlFor="txtGrNo">
                            Exam Name <span className="text-danger">*</span>
                          </label>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-floating mb-2">
                          <select
                            className="form-control"
                            value={value.programId}
                            onChange={(e) =>
                              setValue({ ...value, programId: e.target.value })
                            }
                            required
                          >
                            <option value="">Select Program</option>
                            {programs.map((program) => (
                              <option key={program.id} value={program.id}>
                                {program.name}
                              </option>
                            ))}
                          </select>
                          <label className="form-label" htmlFor="txtGrNo">
                            Program <span className="text-danger">*</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="container mb-1 p-0">
                      {value.subjects.map((subject, index) => (
                        <div
                          className="row gx-4 align-items-center"
                          key={index}
                        >
                          {/* Subject Selection */}
                          <div className="col-md-3 text-center">
                            <label className="text-danger">
                              Select Subject*
                            </label>
                            <div className="form-floating">
                              <select
                                className="form-select"
                                value={subject.subjectId}
                                onChange={(e) => {
                                  const updatedSubjects = [...value.subjects];
                                  updatedSubjects[index].subjectId =
                                    e.target.value;
                                  setValue({
                                    ...value,
                                    subjects: updatedSubjects,
                                  });
                                }}
                                required
                              >
                                <option value="">Select</option>
                                {getAvailableSubjects(index).map(
                                  (subjectOption) => (
                                    <option
                                      key={subjectOption.id}
                                      value={subjectOption.id}
                                    >
                                      {subjectOption.name} (
                                      {subjectOption.subjectCode})
                                    </option>
                                  )
                                )}
                              </select>
                              <label className="form-label form-label-exam">
                                Subject <span className="text-danger">*</span>
                              </label>
                            </div>
                          </div>

                          {/* External Exam */}
                          <div className="col-md-3 text-center">
                            <label className="text-danger">
                              External Exam*
                            </label>
                            <div className="d-flex">
                              <div className="form-floating me-2">
                                <input
                                  className="form-control"
                                  type="number"
                                  name="totalMarks"
                                  placeholder="Total Marks"
                                  required
                                  value={subject.totalMarks}
                                  onChange={(e) => {
                                    const updatedSubjects = [...value.subjects];
                                    updatedSubjects[index].totalMarks =
                                      e.target.value;
                                    setValue({
                                      ...value,
                                      subjects: updatedSubjects,
                                    });
                                  }}
                                  onWheel={(e) => e.target.blur()}
                                />
                                <label className="form-label form-label-exam">
                                  Total Marks{' '}
                                  <span className="text-danger">*</span>
                                </label>
                              </div>
                              <div className="form-floating">
                                <input
                                  className="form-control"
                                  type="number"
                                  name="passingMarks"
                                  placeholder="Passing Marks"
                                  required
                                  value={subject.passingMarks}
                                  onChange={(e) => {
                                    const updatedSubjects = [...value.subjects];
                                    updatedSubjects[index].passingMarks =
                                      e.target.value;
                                    setValue({
                                      ...value,
                                      subjects: updatedSubjects,
                                    });
                                  }}
                                  onWheel={(e) => e.target.blur()}
                                />
                                <label className="form-label form-label-exam">
                                  Passing Marks{' '}
                                  <span className="text-danger">*</span>
                                </label>
                              </div>
                            </div>
                          </div>

                          {/* Internal Exam */}
                          <div className="col-md-3 text-center">
                            <label className="text-danger">
                              Internal Exam*
                            </label>
                            <div className="d-flex">
                              <div className="form-floating me-2">
                                <input
                                  className="form-control"
                                  type="number"
                                  name="internalTotalMark"
                                  placeholder="Internal Total Marks"
                                  required
                                  value={subject.internalTotalMark}
                                  onChange={(e) => {
                                    const updatedSubjects = [...value.subjects];
                                    updatedSubjects[index].internalTotalMark =
                                      e.target.value;
                                    setValue({
                                      ...value,
                                      subjects: updatedSubjects,
                                    });
                                  }}
                                  onWheel={(e) => e.target.blur()}
                                />
                                <label className="form-label form-label-exam">
                                  Total Marks{' '}
                                  <span className="text-danger">*</span>
                                </label>
                              </div>
                              <div className="form-floating">
                                <input
                                  className="form-control"
                                  type="number"
                                  name="internalPassMark"
                                  placeholder="Internal Passing Marks"
                                  required
                                  value={subject.internalPassMark}
                                  onChange={(e) => {
                                    const updatedSubjects = [...value.subjects];
                                    updatedSubjects[index].internalPassMark =
                                      e.target.value;
                                    setValue({
                                      ...value,
                                      subjects: updatedSubjects,
                                    });
                                  }}
                                  onWheel={(e) => e.target.blur()}
                                />
                                <label className="form-label form-label-exam">
                                  Passing Marks{' '}
                                  <span className="text-danger">*</span>
                                </label>
                              </div>
                            </div>
                          </div>

                          {/* OMR */}
                          <div className="col-md-2 text-center">
                            <label className="text-danger">OMR Marks</label>
                            <div className="form-floating">
                              <input
                                className="form-control"
                                type="number"
                                name="omrMarks"
                                min={0}
                                placeholder="OMR Marks"
                                value={subject.omrTotalMark || ''}
                                onChange={(e) => {
                                  const updatedSubjects = [...value.subjects];
                                  updatedSubjects[index].omrTotalMark =
                                    e.target.value;
                                  setValue({
                                    ...value,
                                    subjects: updatedSubjects,
                                  });
                                }}
                                onWheel={(e) => e.target.blur()}
                              />
                              <label className="form-label form-label-exam">
                                OMR Marks
                              </label>
                            </div>
                          </div>

                          {/* Remove Button */}
                          <div className="col-md-1 text-center">
                            <button
                              type="button"
                              className="btn btn-danger exam-remove-button"
                              onClick={() => handleDeleteSubject(index)}
                            >
                              <i className="bi bi-trash-fill"></i>
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>

                    <div className="row text-end button-edit-exam ">
                      <div className="d-flex flex-row justify-content-end ms-3">
                        <div className="p-2 mt-2">
                          <label>
                            <IoSettings size={25} className="pb-1" />
                            <strong>Allocation Setting for Faculties</strong>
                          </label>
                        </div>
                        <div className="p-2 col-1">
                          <select
                            className="form-select"
                            value={value.facultyCount}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                facultyCount: parseInt(e.target.value),
                              })
                            }
                          >
                            <option value="1">1</option>
                            <option value="2">2</option>
                          </select>
                        </div>
                        <div className="p-2">
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleAddSubject}
                          >
                            <i className="bi bi-journal-plus"></i>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="row mx-3">
                      <div className="col-sm-12 pt-4 text-end">
                        <button
                          type="button"
                          className="btn btn-primary px-3"
                          onClick={() => navigate(-1)}
                        >
                          <i className="bi bi-arrow-bar-left"></i> Back
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary px-4 mx-2"
                          disabled={isLoading}
                        >
                          {isLoading ? 'Saving...' : 'Save'}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <ToastContainer position="top-center" style={{ width: 'auto' }} />
    </AdminLayout>
  );
}
